// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ZdBz","unreadBadge":"styles_unreadBadge__3-oJX","modalContent":"styles_modalContent__XvxlB","modal":"styles_modal__3w_jR"};